import {
  Button,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icons,
} from '@commenda/kakashi';

interface CancelSubscriptionStepProps {
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  nextPaymentAmount: number;
  nextPaymentDate: string;
  planNames: string[];
}

export const CancelSubscriptionStep = ({
  onClose,
  onConfirm,
  title,
  nextPaymentAmount,
  nextPaymentDate,
  planNames,
}: CancelSubscriptionStepProps) => {
  return (
    <div className="w-[660px] max-w-[660px] rounded-lg shadow-3xl">
      <DialogHeader>
        <DialogTitle>Cancel {title}</DialogTitle>
      </DialogHeader>

      <div className="p-3xl space-y-3xl">
        <div className="bg-utility-violet-50 rounded-lg gap-xl p-2xl">
          <div className="flex items-center justify-between">
            <h2 className="text-xl-bold text-text-primary">{title}</h2>
            <div className="flex items-baseline">
              <span className="text-md-bold text-text-primary">
                ${nextPaymentAmount}
              </span>
              <span className="text-sm-regular text-text-tertiary ml-1">
                {' '}
                /year
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-xl">
          <h3 className="text-md-bold text-text-primary">
            By cancelling this subscription, you will lose access to:
          </h3>
          <ul className="space-y-3">
            {planNames.map((planName, index) => (
              <li key={index} className="flex items-start gap-3">
                <Icons.Check className="h-5 w-5 text-fg-success" />
                <span className="text-sm-regular text-text-secondary">
                  {planName}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <DialogFooter>
        <Button variant="destructive-secondary" size="md" onClick={onConfirm}>
          I want to cancel
        </Button>
        <Button variant="primary" size="md" onClick={onClose}>
          Keep my subscription
        </Button>
      </DialogFooter>
    </div>
  );
};

export default CancelSubscriptionStep;
